import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../Styles/IPLProductStyle.css";
import iplHeroImage from '../Assets/revd.png';
import iplInUse from '../Assets/revt.png';
import iplBeforeAfter from '../Assets/laww.png';
import iplBeforeAfter1 from '../Assets/hhb.png';
import iplFilters from '../Assets/revivff.png';
import iplBackground from '../Assets/revivback.png';

const IPLRevivePage = () => {
  // useEffect(() => {
  //   AOS.init({
  //     duration: 800,
  //     easing: 'ease-in-out',
  //     once: false
  //   });
  // }, []);

  // const handleOpenPDF = () => {
  // window.open("https://romanqadir.github.io/jsonapi/REVIVE.pdf"); // Update with your PDF path
  // };
const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/REVIVE.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'ipl-revie.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/REVIVE.pdf", '_blank');
    });
};
  // Skin concerns data from PDF
  const skinConcerns = [
  {
    id: 1,
    title: "Acne & Oil Control",
    wavelength: "420-600 nm",
    description: "Targets P. acnes bacteria, reduces sebaceous gland activity, controls inflammation",
    imageUrl: "https://i.pinimg.com/736x/d9/69/34/d96934dbbc5ebb93769a9e1d72f45b98.jpg" // Replace with actual acne icon URL
  },
  {
    id: 2,
    title: "Pigmentation Correction",
    wavelength: "515-755 nm",
    description: "Lightens dark spots, evens skin tone for epidermal and dermal pigmentation",
imageUrl: "https://i.pinimg.com/736x/7c/80/a3/7c80a3d4e3315292d0f8261c551a5989.jpg"  // Add your URL
  },
  {
    id: 3,
    title: "Vascular Lesions",
    wavelength: "530-590 nm",
    description: "Treats rosacea, flushing, fine vessels and larger facial/leg veins",
    imageUrl: "https://i.pinimg.com/1200x/43/14/5b/43145beaa021c4f026508b49aab5d673.jpg" // Add your URL
  },
  {
    id: 4,
    title: "Skin Rejuvenation",
    wavelength: "560-1200 nm",
    description: "Stimulates collagen, tightens skin, reduces fine lines and wrinkles",
    imageUrl: "https://i.pinimg.com/1200x/74/e6/f8/74e6f80605dd9192c622e4df25a4c010.jpg" // Add your URL
  },
  {
    id: 5,
    title: "Hair Removal",
    wavelength: "Multiple ranges",
    description: "Effective permanent hair reduction for all skin types",
    imageUrl: "https://i.pinimg.com/736x/28/0b/6d/280b6d87efac408febb64462a504abad.jpg" // Add your URL
  },
  {
    id: 6,
    title: "Anti-Aging",
    wavelength: "560-1200 nm",
    description: "Deep anti-aging treatment for comprehensive skin renewal",
    imageUrl: "https://i.pinimg.com/1200x/8a/5e/02/8a5e02a063e9edaf05559744c2ee1e3c.jpg" // Add your URL
  }
];

  const technologies = [
    {
      name: "OPT Technology",
      description: "Optimal Pulse Technology delivers homogeneous power over long pulse durations for precise treatment",
      features: ["High peak power", "Shorter pulses", "Optimal for photo rejuvenation", "Reduced discomfort"]
    },
    {
      name: "MSP Technology",
      description: "Multiple-Sequential Pulsing allows skin cooling between pulses, minimizing damage risk",
      features: ["Inter-pulse cooling", "Lower injury threshold", "Better epidermis protection", "Enhanced safety"]
    },
    {
      name: "Quick-Change Filters",
      description: "Magnetic spot size adapters for instant adjustment between treatment areas",
      features: ["Magnetic attachment", "Multiple sizes", "Contoured areas", "Quick switching"]
    }
  ];

  return (
    <div className="ipl-product-page">
      {/* Hero Section */}
      <section 
        className="ipl-hero-section" 
        style={{ backgroundImage: `url(${iplBackground})` }}
      >
        <Container>
          <Row className="align-items-center min-vh-80">
            <Col md={6} className="hero-content" data-aos="fade-right">
              <h1 className="product-title animate-charcter-ipl">EPILYUM REVIVE</h1>
              <h2 className="product-subtitle typed-text">
                Intense Pulsed Light System 2026
              </h2>
              <p className="hero-description" data-aos="fade-up" data-aos-delay="200">
                Advanced IPL system with OPT & MSP technology for over 20 skin concerns
              </p>
              <div className="hero-badges" data-aos="fade-up" data-aos-delay="300">
                <span className="badge">CE Certified</span>
                <span className="badge">ISO 9001</span>
                <span className="badge">OPT Technology</span>
              </div>
            </Col>
            <Col md={6} className="text-center" data-aos="fade-left" data-aos-delay="200">
              <Image 
                src={iplHeroImage} 
                fluid 
                className="product-hero-image ipl-floating" 
                alt="Epilyum IPL Revive Device"
              />
              <div className="device-specs" data-aos="fade-up" data-aos-delay="400" >
                <div className="spec-item " >
                  <i className="fas fa-bolt"></i>
                  <span style={{color:'black'}} > 3000W Power</span>
                </div>
                <div className="spec-item">
                  <i className="fas fa-ruler-combined"></i>
                  <span style={{color:'black'}}>420-1200 nm</span>
                </div>
                <div className="spec-item">
                  <i className="fas fa-snowflake"></i>
                  <span style={{color:'black'}}>Advanced Cooling</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Introduction Section */}
      <section className="ipl-intro-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center" data-aos="fade-up">
              <div className="ipl-icon mb-4" data-aos="zoom-in">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h2 className="section-title ipl-title mb-4">
                Advanced IPL Technology
              </h2>
              <p className="intro-text ipl-description">
                Epilyum IPL is an advanced Intense Pulsed Light system designed to address 
                over 20 skin concerns including acne treatment, pigmentation correction, 
                vascular lesion removal, skin rejuvenation, and hair removal. Utilizing 
                Optimal Pulse Technology (OPT) and Multiple Sequential Pulsing (MSP) with 
                its advanced cooling system, Epilyum ensures safe, effective, and precise 
                treatments with minimal discomfort.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Skin Concerns Section */}
      <section className="skin-concerns-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title ipl-title" data-aos="fade-up">
                Comprehensive <span className="text-highlight">Skin Solutions</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                Target specific skin concerns with precise wavelength ranges
              </p>
            </Col>
          </Row>
          
        <Row className="g-4">
  {skinConcerns.map((concern, index) => (
    <Col md={4} lg={2} key={concern.id} data-aos="fade-up" data-aos-delay={index * 100}>
      <div className="concern-card">

          <img 
            src={concern.imageUrl} 
            alt={concern.title}
            className="concern-circle-image"
          />
       <br></br>
        <h5>{concern.title}</h5>
        <div className="wavelength-badge">
          <i className="fas fa-wave-square me-1"></i>
          {concern.wavelength}
        </div>
        <p className="concern-description">{concern.description}</p>
      </div>
    </Col>
  ))}
</Row>
        </Container>
      </section>

      {/* Technology Features */}
      <section className="technology-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title ipl-title" data-aos="fade-up">
                Advanced <span className="text-highlight">Technology</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4 align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="tech-image-container">
                <Image 
                  src={iplFilters} 
                  fluid 
                  className="tech-image rounded-lg shadow-lg" 
                  alt="IPL Filters and Applications"
                />
                <div className="floating-label" data-aos="fade-up-left">
                  <span>Quick-Change Filters</span>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="tech-list">
                {technologies.map((tech, index) => (
                  <div className="tech-item" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                    <h4>{tech.name}</h4>
                    <p>{tech.description}</p>
                    <div className="tech-features">
                      {tech.features.map((feature, fIndex) => (
                        <span className="feature-badge" key={fIndex}>
                          <i className="fas fa-check me-1"></i>
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Before/After Section */}
      <section className="before-after-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title ipl-title" data-aos="fade-up">
                Clinical <span className="text-highlight">Results</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="justify-content-center">
            <Col lg={10} data-aos="zoom-in">
              <div className="comparison-container">
                <div className="comparison-slider">
                  <Image 
                    src={iplBeforeAfter} 
                    fluid 
                    className="comparison-image shadow-lg" 
                    alt="Before and After IPL Treatment"
                  />
                  <div className="comparison-labels">
                    <span className="before-label">Before</span>
                    <span className="after-label">After</span>
                  </div>
                </div>
             
              </div>
            </Col>
          
          
          </Row>
          <br></br>
           <Row className="justify-content-center">
            <Col lg={10} data-aos="zoom-in">
              <div className="comparison-container">
                <div className="comparison-slider">
                  <Image 
                    src={iplBeforeAfter1} 
                    fluid 
                    className="comparison-image shadow-lg" 
                    alt="Before and After IPL Treatment"
                  />
                  <div className="comparison-labels">
                    <span className="before-label">Before</span>
                    <span className="after-label">After</span>
                  </div>
                </div>
             
              </div>
            </Col>
          
          
          </Row>
        </Container>
      </section>

      {/* Technical Specifications */}
      <section className="specs-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 style={{color:'white'}} className="section-title ipl-title" data-aos="fade-up">

                Technical <span className="text-highlight">Specifications</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="specs-table" data-aos="fade-up">
                <table className="table table-striped table-hover">
                  <tbody>
                    <tr>
                      <td><strong>Model</strong></td>
                      <td>Epilyum Revive 2026</td>
                    </tr>
                    <tr>
                      <td><strong>Wavelength Range</strong></td>
                      <td>420-755 nm (filter dependent)</td>
                    </tr>
                    <tr>
                      <td><strong>Fluence</strong></td>
                      <td>5-25 J/cm²</td>
                    </tr>
                    <tr>
                      <td><strong>Spot Size</strong></td>
                      <td>10 × 40 mm</td>
                    </tr>
                    <tr>
                      <td><strong>Input Power</strong></td>
                      <td>3000W</td>
                    </tr>
                    <tr>
                      <td><strong>Pulse Duration</strong></td>
                      <td>1-350 ms</td>
                    </tr>
                    <tr>
                      <td><strong>Cooling Temperature</strong></td>
                      <td>-4°C to 20°C (Adjustable)</td>
                    </tr>
                    <tr>
                      <td><strong>Certifications</strong></td>
                      <td>CE, ISO 9001</td>
                    </tr>
                    <tr>
                      <td><strong>Voltage</strong></td>
                      <td>220V</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Catalog Section */}
      <section className="ipl-catalog-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h2 className="section-title ipl-title mb-4">
                Download <span className="text-highlight">Full Catalogue</span>
              </h2>
              <p className="lead mb-5">
                Complete technical specifications, clinical protocols, and treatment guides
              </p>
              
              <div className="catalog-preview mb-5" data-aos="zoom-in">
                <div className="catalog-frame ipl-catalog">
                  <div className="catalog-cover">
                    <h3>EPILYUM REVIVE</h3>
                    <p>Intense Pulsed Light System</p>
                    <div className="catalog-features">
                      <span><i className="fas fa-check"></i> OPT Technology</span>
                      <span><i className="fas fa-check"></i> MSP Technology</span>
                      <span><i className="fas fa-check"></i> Advanced Cooling</span>
                    </div>
                  </div>
                  <div className="catalog-overlay" onClick={handleOpenPDF}>
                    <span className="overlay-text">Click to Preview</span>
                  </div>
                </div>
              </div>
              
              <button 
                onClick={handleOpenPDF}
                className="btn btn-primary btn-lg download-btn pulse"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <i className="fas fa-download me-2"></i> Download IPL Catalogue (PDF)
              </button>
              
              <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="300">
                <small>Includes complete wavelength specifications and treatment protocols</small>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Safety Notice */}
      <section className="safety-section py-4 bg-dark text-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <div className="safety-alert" data-aos="fade-up">
                <i className="fas fa-exclamation-triangle me-3"></i>
                <span>
                  <strong>Important:</strong> IPL systems are intended for use by qualified dermatologists trained in IPL technology. 
                  Always read and understand the operator manual before use.
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default IPLRevivePage;